import { render } from "./PatientSearch.vue?vue&type=template&id=b4a10150&scoped=true&ts=true"
import script from "./PatientSearch.vue?vue&type=script&lang=ts"
export * from "./PatientSearch.vue?vue&type=script&lang=ts"

import "./PatientSearch.vue?vue&type=style&index=0&id=b4a10150&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a10150"]])

export default __exports__